import * as tslib_1 from "tslib";
import ComposeDropHint from './ComposeDropHint';
import { observer } from 'mobx-react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { AttachmentFileType, lazyCreateLocalComputerFiles, lazyCreateMailItemFiles, } from 'owa-attachment-common';
import { isAttachmentFeatureEnabled } from 'owa-attachment-feature-flags';
import { AttachmentWellView } from 'owa-attachment-well-view';
import Droppable from 'owa-dnd/lib/components/Droppable';
import { DraggableItemTypes } from 'owa-dnd/lib/utils/DraggableItemTypes';
import { ReactEditor } from 'owa-editor';
import getMentionClassName from 'owa-editor-mentionsplugin/lib/utils/getMentionClassName';
import { PasteOption } from 'owa-editor-paste-option-plugin';
import { ContextualFormatBar } from 'owa-editor-ribbonplugin';
import { TableEditContextMenu } from 'owa-editor-table-edit-plugin';
import moveComposeToTab from 'owa-mail-compose-store/lib/actions/moveComposeToTab';
import setIsFocusWorkaroundDivShown from 'owa-mail-compose-store/lib/actions/setIsFocusWorkaroundDivShown';
import triggerPolicyTips from 'owa-mail-compose-store/lib/actions/triggerPolicyTips';
import upConvert from 'owa-mail-compose-store/lib/actions/upConvert';
import updateLastFocusedControl from 'owa-mail-compose-store/lib/actions/updateLastFocusedControl';
import moveAttachmentToInlineHandler from 'owa-mail-compose-store/lib/utils/moveAttachmentToInlineHandler';
import { getPluginArray } from 'owa-mail-compose-store/lib/plugins/ComposePlugins';
import { addViewStateToBeforeUnloadHandler } from 'owa-mail-compose-store/lib/utils/beforeUnloadHandler';
import createAttachments from 'owa-mail-compose-store/lib/utils/createAttachments';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import isReadingPaneCardUIEnabled from 'owa-mail-feature-flags/lib/isReadingPaneCardUIEnabled';
import { getCurrentTableMailboxInfo } from 'owa-mail-mailboxinfo';
import { mailStore } from 'owa-mail-store';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import strings from 'owa-strings/owa-mail-strings';
import isTabViewEnabled from 'owa-tab-store/lib/utils/isTabViewEnabled';
import { isBrowserEdge, isBrowserIE } from 'owa-user-agent/lib/userAgent';
import * as React from 'react';
import { infoBarAddHandler, infoBarRemoveHandler, } from 'owa-mail-compose-store/lib/utils/infoBarHandlers';
import logEditorPerf from '../utils/logEditorPerf';
var styles = require('./ComposeBody.scss');
var classNames = require('classnames/bind').bind(styles);
// Workaround for Edge to leave some space blow cursor to avoid content jump when add new line
var EDITOR_MIN_HEIGHT = 250;
var PRESERVED_SPACE_FOR_EDGE = 20;
var ComposeBody = /** @class */ (function (_super) {
    tslib_1.__extends(ComposeBody, _super);
    function ComposeBody() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.trySetFocus = function () {
            _this.props.plugins.contentOperationPlugin.focusToEditor();
        };
        _this.setHeight = function () {
            var editor = _this.reactEditor ? _this.reactEditor.getInnerComponent() : null;
            if (editor && _this.editorContainer) {
                var contentHeight = editor.getContentHeight();
                if (contentHeight > EDITOR_MIN_HEIGHT) {
                    contentHeight += PRESERVED_SPACE_FOR_EDGE;
                }
                _this.editorContainer.style.height = contentHeight + 'px';
            }
        };
        _this.refCallback = function (ref) {
            var plugins = _this.props.plugins;
            var div = ref ? ref.getDiv() : null;
            if (plugins.dockingPlugin) {
                plugins.dockingPlugin.setDockingTriggerPart(div);
            }
            if (plugins.inlineImageResizePlugin) {
                plugins.inlineImageResizePlugin.addOnImportedCallback(function (plugin) {
                    return plugin.setComposeBodyWrapperDiv(div);
                });
            }
        };
        _this.shouldShowComposeDropHint = function () {
            // Compose body only allows to drop MailListRow and LocalFile.
            return (isAttachmentFeatureEnabled('doc-attachment-composeDropHint') &&
                (mailStore.typeOfItemBeingDragged === DraggableItemTypes.MailListRow ||
                    mailStore.typeOfItemBeingDragged === DraggableItemTypes.LocalFile ||
                    mailStore.typeOfItemBeingDragged === DraggableItemTypes.Attachment));
        };
        _this.onAttachmentDeleted = function () {
            if (isMailFeatureEnabled('cmp-encryption')) {
                // When attachment is deleted, check DLP information.
                triggerPolicyTips(_this.props.viewState, 16 /* AttachmentRemoved */);
            }
        };
        _this.onPlainTextChange = function () {
            _this.props.plugins.contentOperationPlugin.updateContentToViewState();
        };
        _this.onUpConvert = function () {
            if (isTabViewEnabled()) {
                moveComposeToTab(_this.props.viewState, true /*isShown*/, true /*makeActive*/);
            }
            else {
                upConvert(_this.props.viewState);
            }
        };
        _this.onDrop = function (dragInfo) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var attachmentFileList, shouldShare, _a, filesDragData, createLocalComputerFiles, mailListItemsDragData, createConversationFiles, mailListItemPartDragData, createItemFiles, attachmentDragData;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        attachmentFileList = null;
                        shouldShare = false;
                        _a = dragInfo.itemType;
                        switch (_a) {
                            case DraggableItemTypes.LocalFile: return [3 /*break*/, 1];
                            case DraggableItemTypes.MailListRow: return [3 /*break*/, 4];
                            case DraggableItemTypes.MailListItemPart: return [3 /*break*/, 7];
                            case DraggableItemTypes.Attachment: return [3 /*break*/, 10];
                        }
                        return [3 /*break*/, 11];
                    case 1:
                        filesDragData = dragInfo;
                        return [4 /*yield*/, lazyCreateLocalComputerFiles.import()];
                    case 2:
                        createLocalComputerFiles = _b.sent();
                        return [4 /*yield*/, createLocalComputerFiles(filesDragData.files)];
                    case 3:
                        attachmentFileList = _b.sent();
                        return [3 /*break*/, 12];
                    case 4:
                        mailListItemsDragData = dragInfo;
                        return [4 /*yield*/, lazyCreateMailItemFiles.import()];
                    case 5:
                        createConversationFiles = _b.sent();
                        return [4 /*yield*/, createConversationFiles(mailListItemsDragData.subjects, mailListItemsDragData.latestItemIds)];
                    case 6:
                        attachmentFileList = _b.sent();
                        return [3 /*break*/, 12];
                    case 7:
                        mailListItemPartDragData = dragInfo;
                        return [4 /*yield*/, lazyCreateMailItemFiles.import()];
                    case 8:
                        createItemFiles = _b.sent();
                        return [4 /*yield*/, createItemFiles(mailListItemPartDragData.subjects, mailListItemPartDragData.itemIds)];
                    case 9:
                        attachmentFileList = _b.sent();
                        return [3 /*break*/, 12];
                    case 10:
                        attachmentDragData = dragInfo;
                        attachmentFileList = [attachmentDragData.attachmentFile];
                        shouldShare =
                            attachmentDragData.attachmentFile.fileType === AttachmentFileType.Cloud;
                        return [3 /*break*/, 12];
                    case 11: return [3 /*break*/, 12];
                    case 12:
                        if (attachmentFileList) {
                            createAttachments(attachmentFileList, false, this.props.viewState, shouldShare, false /* isHiddenInline */, null);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.canDrop = function (dragInfo) {
            var itemType = dragInfo.itemType;
            return (itemType === DraggableItemTypes.LocalFile ||
                itemType === DraggableItemTypes.MailListItemPart ||
                itemType === DraggableItemTypes.MailListRow ||
                itemType === DraggableItemTypes.Attachment);
        };
        _this.onEditorFocus = function () {
            setIsFocusWorkaroundDivShown(_this.props.viewState, false /*isShown*/);
            updateLastFocusedControl(_this.props.viewState, 7 /* Editor */);
        };
        _this.onEditorBlur = function () {
            setIsFocusWorkaroundDivShown(_this.props.viewState, true /*isShown*/);
        };
        return _this;
    }
    ComposeBody.prototype.componentDidMount = function () {
        addViewStateToBeforeUnloadHandler(this.props.viewState);
        // Workaround Edge performance issue by setting fixed width and height to editor
        var plugins = this.props.plugins;
        plugins.dockingPlugin.setOnCursorTopChanged(this.setHeight);
    };
    ComposeBody.prototype.componentWillUnmount = function () {
        var plugins = this.props.plugins;
        plugins.dockingPlugin.setOnCursorTopChanged(null);
    };
    ComposeBody.prototype.render = function () {
        var viewState = this.props.viewState;
        var attachmentWell = viewState.attachmentWell;
        var hasAttachment = (attachmentWell.docViewAttachments && attachmentWell.docViewAttachments.length > 0) ||
            (attachmentWell.imageViewAttachments && attachmentWell.imageViewAttachments.length > 0);
        var bodyClassNames = classNames(styles.bodyContainer, {
            cardUI: isReadingPaneCardUIEnabled(),
            hasAttachment: hasAttachment,
            isInlineCompose: viewState.isInlineCompose,
            sticky: viewState.docking && viewState.docking.useStickyDocking,
        });
        return (React.createElement(Droppable, { classNames: bodyClassNames, ref: this.refCallback, dropViewState: viewState.dropViewState, onDrop: this.onDrop, canDrop: this.canDrop, shouldUseCopyAsDropEffect: true, shouldIgnoreTransientOnDragLeave: true },
            this.renderAttachmentWell(),
            this.renderFocusWorkaroundDiv(),
            this.renderEditor(),
            this.renderFocusWorkaroundDiv(),
            this.renderContextualFormatBar(),
            this.renderEditTableMenu(),
            this.renderPasteOption(),
            this.renderShowHistoryBar(),
            this.renderDropHint()));
    };
    // Workaround Edge performance issue by setting fixed width and height
    ComposeBody.prototype.setWidth = function (width) {
        if (this.editorContainer) {
            this.editorContainer.style.width = width + 'px';
        }
    };
    ComposeBody.prototype.renderDropHint = function () {
        return (this.shouldShowComposeDropHint() && (React.createElement(ComposeDropHint, { dataTransferType: mailStore.typeOfItemBeingDragged, dropViewState: this.props.viewState.dropViewState, dockingPlugin: this.props.plugins.dockingPlugin })));
    };
    ComposeBody.prototype.renderAttachmentWell = function () {
        var viewState = this.props.viewState;
        var parentItemId = tslib_1.__assign({}, viewState.itemId, { mailboxInfo: getCurrentTableMailboxInfo() });
        return (React.createElement(AttachmentWellView, { attachmentWellViewState: viewState.attachmentWell, parentItemId: parentItemId, isDraft: true, infoBarAddHandler: infoBarAddHandler(this.props.viewState), infoBarRemoveHandler: infoBarRemoveHandler(this.props.viewState), onAttachmentDeletedCallback: this.onAttachmentDeleted, moveAttachmentToInlineHandler: function (attachment, contentId) {
                moveAttachmentToInlineHandler(viewState, attachment, contentId);
            } }));
    };
    ComposeBody.prototype.renderEditor = function () {
        var _this = this;
        var _a = this.props, viewState = _a.viewState, plugins = _a.plugins;
        var isHtmlEditor = this.props.viewState.bodyType == 'HTML';
        var editorClassNames = classNames(styles.editorBody, {
            isInlineCompose: viewState.isInlineCompose,
            hasRibbon: viewState.isRibbonShown,
            plainTextEditor: !isHtmlEditor,
        });
        var isRtl = getUserConfiguration().SessionSettings.IsUserCultureRightToLeft;
        // TODO: VSO 1311: Temporarily keep TextArea for now. We will finally implement a PlainText editor using CED and remove TextArea
        return isHtmlEditor ? (React.createElement("div", { ref: function (ref) { return (_this.editorContainer = ref); }, className: styles.editorSizeContainer },
            React.createElement(ReactEditor, { ref: function (ref) { return (_this.reactEditor = ref); }, plugins: getPluginArray(plugins), undo: plugins.undo, viewState: viewState, classNames: editorClassNames, onFocus: this.onEditorFocus, onBlur: this.onEditorBlur, showFormatPainterCursor: !!viewState.ribbon.formatViewState.formatPainterFormat, isRtl: isRtl, cssClassesToPreserveWhenPaste: [getMentionClassName()], logPerfDataCallback: isMailFeatureEnabled('cmp-editorPerfMeasure') ? logEditorPerf : null, ariaLabel: strings.messageBodyAriaLabel }))) : (React.createElement("div", null,
            React.createElement("textarea", { className: editorClassNames, placeholder: strings.addMessage, ref: function (ref) {
                    if (_this.props.plugins.contentOperationPlugin) {
                        _this.props.plugins.contentOperationPlugin.setPlainTextEditor(ref);
                    }
                }, onChange: this.onPlainTextChange, value: viewState.content })));
    };
    ComposeBody.prototype.renderContextualFormatBar = function () {
        return (React.createElement(ContextualFormatBar, { className: styles.contextualFormatBar, ribbonPlugin: this.props.plugins.ribbonPlugin, viewState: this.props.viewState.ribbon }));
    };
    ComposeBody.prototype.renderPasteOption = function () {
        var pasteOptionPlugin = this.props.plugins.pasteOptionPlugin;
        return (pasteOptionPlugin && (React.createElement(PasteOption, { viewState: this.props.viewState.pasteOption, plugin: pasteOptionPlugin })));
    };
    ComposeBody.prototype.renderShowHistoryBar = function () {
        var viewState = this.props.viewState;
        return (viewState.isInlineCompose && (React.createElement("div", { className: styles.showHistoryButton, onClick: this.onUpConvert, title: strings.showMessageHistory },
            React.createElement(Icon, { iconName: "More" /* More */ }))));
    };
    ComposeBody.prototype.renderEditTableMenu = function () {
        return (React.createElement(TableEditContextMenu, { viewState: this.props.viewState.tableEdit, plugin: this.props.plugins.tableEdit }));
    };
    // Workaround a behavior in Edge/IE
    // Add an extra DIV before and after editor to accept the focus by press TAB/Shift+Tab then use code to trigger the real focus into editor
    // So that the view will not do auto scroll
    ComposeBody.prototype.renderFocusWorkaroundDiv = function () {
        return ((isBrowserEdge() || isBrowserIE()) &&
            this.props.viewState.isFocusWorkaroundDivShown && (React.createElement("div", { onFocus: this.trySetFocus, tabIndex: 0 })));
    };
    ComposeBody = tslib_1.__decorate([
        observer
    ], ComposeBody);
    return ComposeBody;
}(React.Component));
export default ComposeBody;
//# sourceMappingURL=ComposeBody.js.map